import { z } from 'zod';

export type MediaItemSizeEnum =
  | 'BLUR'
  | 'LARGE'
  | 'MEDIUM'
  | 'MEDIUM_LARGE'
  | 'THUMBNAIL'
  | '_1536X1536'
  | '_2048X2048';

export const imageQuery = (
  size: MediaItemSizeEnum = 'MEDIUM_LARGE'
) => /* graphql */ `
  node {
    id
    mimeType
    altText
    sizes(size: ${size})
    sourceUrl
    srcSet
    blurDataUrl

    mediaDetails {
      width
      height

      sizes {
        name
        width
        height
        mimeType
        sourceUrl
      }
    }
  }
`;

export const imageWpSizesSchema = z.union([
  z.literal('blur'),
  z.literal('thumbnail'),
  z.literal('medium'),
  z.literal('medium_large'),
  z.literal('large'),
  z.literal('1536x1536'),
  z.literal('2048x2048'),
]);

export type ImageWpSizesSchema = z.infer<typeof imageWpSizesSchema>;

export const imageSchema = z.object({
  node: z.object({
    id: z.string(),
    mimeType: z.string(),
    altText: z.string(),
    sizes: z.string(),
    sourceUrl: z.string(),
    srcSet: z.string(),
    blurDataUrl: z.string().nullish(),
    mediaDetails: z.object({
      width: z.number(),
      height: z.number(),

      sizes: z
        .array(
          z.object({
            name: imageWpSizesSchema,

            width: z.coerce.number(),
            height: z.coerce.number(),

            mimeType: z.string(),
            sourceUrl: z.string(),
          })
        )
        .nullish(),
    }),
  }),
});

export type ImageSchema = z.infer<typeof imageSchema>;
